import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import {
  FE_REAL_TIME_OWF_OVERRIDE_250623,
  REAL_TIME_OWF_BUCKET_OVERRIDE,
} from "@faire/retailer-settings/FE_REAL_TIME_OWF_OVERRIDE_250623";

export const useSettingFERealTimeOwFOverride =
  (): keyof typeof REAL_TIME_OWF_BUCKET_OVERRIDE =>
    useSetting(FE_REAL_TIME_OWF_OVERRIDE_250623);
